"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var ngx_bootstrap_1 = require("ngx-bootstrap");
var BhtpTypeaheadDirective = (function (_super) {
    __extends(BhtpTypeaheadDirective, _super);
    function BhtpTypeaheadDirective(control, viewContainerRef, element, renderer, cis) {
        return _super.call(this, control, viewContainerRef, element, renderer, cis) || this;
    }
    BhtpTypeaheadDirective.prototype.ngOnChanges = function (changes) {
        if (changes) {
            if (changes['bhtpTypeahead'] && this.bhtpTypeahead) {
                this.typeahead = this.bhtpTypeahead;
            }
            if (changes['typeahead'] && this.typeahead) {
                console.warn('DEPRECATION: Please update to specify datasource through bhtpTypeahead instead of typeahead');
            }
        }
    };
    /**
     * Call this method when the keydown event is not supported, and it will attach the keypress event
     * to the input so the typeahead search works
     */
    BhtpTypeaheadDirective.prototype.enableCompatibilityMode = function () {
        var _this = this;
        this.element.nativeElement.addEventListener('keypress', function (e) {
            _super.prototype.onChange.call(_this, e);
        });
    };
    BhtpTypeaheadDirective.prototype.onBlur = function () {
        var payload;
        if (this._container && !this._container.isFocused) {
            payload = this._container.active;
        }
        // Clear out _matches to fix issue where clearing an existing value, typing in new value and leaving will select the previous match
        this._matches = [];
        this.typeaheadOnBlur.emit(payload);
        this.hide();
    };
    return BhtpTypeaheadDirective;
}(ngx_bootstrap_1.TypeaheadDirective));
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], BhtpTypeaheadDirective.prototype, "bhtpTypeahead", void 0);
__decorate([
    core_1.HostListener('blur'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BhtpTypeaheadDirective.prototype, "onBlur", null);
BhtpTypeaheadDirective = __decorate([
    core_1.Directive({ selector: '[bhtpTypeahead]' }),
    __metadata("design:paramtypes", [forms_1.NgControl, core_1.ViewContainerRef, core_1.ElementRef, core_1.Renderer, ngx_bootstrap_1.ComponentLoaderFactory])
], BhtpTypeaheadDirective);
exports.BhtpTypeaheadDirective = BhtpTypeaheadDirective;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/type-ahead/bhtp-typeahead.directive.js